module.exports = __webpack_public_path__ + "img/thumb_11.10db4f23.jpg";